var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'SmartPin',
        to: {
          name: 'smartpininsight'
        }
      }, {
        label: 'Insight',
        to: {
          name: 'smartpininsight'
        }
      }, {
        label: 'Detail Content'
      }],
      "title": "Insight Detail Content"
    }
  }), _c('div', {
    staticClass: "flex w-full flex-col bg-white rounded-xl p-4 shadow-sm mb-3"
  }, [_c('div', {
    staticClass: "flex items-center justify-between mb-4"
  }, [_c('h2', {
    staticClass: "text-xl mb-0 font-bold text-gray-900 tracking-tight"
  }, [_vm._v(" Summary ")]), _c('div', {
    staticClass: "flex items-center gap-3"
  }, [_c('DateRangePicker', {
    attrs: {
      "max-days": 31
    },
    on: {
      "change": _vm.handleDateRangeChange
    },
    model: {
      value: _vm.selectedDateRange,
      callback: function ($$v) {
        _vm.selectedDateRange = $$v;
      },
      expression: "selectedDateRange"
    }
  }), _c('div', {
    staticClass: "w-56"
  }, [_c('CustomSelected', {
    staticClass: "cursor-pointer",
    attrs: {
      "value": _vm.selectedLocationOption,
      "options": _vm.locationOptions,
      "label": "name",
      "track-by": "value",
      "multiple": false,
      "default-text": 'All Locations'
    },
    on: {
      "input": _vm.handleLocationChange
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "grid grid-cols-1 lg:grid-cols-2 gap-10"
  }, [_c('MostContentCard', {
    attrs: {
      "variant": "purchase",
      "total": _vm.mostPurchase.total,
      "items": _vm.mostPurchase.items,
      "is-loading": _vm.isLoadingMostPurchase
    }
  }), _c('MostContentCard', {
    attrs: {
      "variant": "read",
      "total": _vm.mostRead.total,
      "items": _vm.mostRead.items,
      "is-loading": _vm.isLoadingMostRead
    }
  })], 1)]), _c('div', {
    staticClass: "flex w-full flex-col bg-white rounded-xl p-4 shadow-sm mb-5"
  }, [_c('div', {
    staticClass: "flex justify-between items-center mb-4"
  }, [_c('div', {
    staticClass: "relative w-96"
  }, [_c('SearchOutline', {
    attrs: {
      "className": "absolute top-1/2 left-3 transform -translate-y-1/2"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchQuery,
      expression: "searchQuery"
    }],
    staticClass: "w-full py-2.5 pl-9 pr-3 text-sm border border-gray-300 rounded-lg bg-gray-50",
    attrs: {
      "type": "search",
      "placeholder": "Search by Content Title"
    },
    domProps: {
      "value": _vm.searchQuery
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) { return; }
        _vm.searchQuery = $event.target.value;
      }, _vm.onSearch]
    }
  })], 1), _c('ExportCsvButton', {
    attrs: {
      "is-empty": !_vm.totalRows,
      "is-exporting": _vm.isExporting,
      "countdown": _vm.exportCountdown,
      "countdown-text": _vm.formattedExportCountdown
    },
    on: {
      "click": _vm.exportCsv
    }
  })], 1), _c('DataTable', {
    attrs: {
      "headers": _vm.headers,
      "data": _vm.tableRows,
      "row-key": ['content_title', 'author'].concat(_vm.metricKeys),
      "currentPage": _vm.currentPage,
      "perPage": _vm.perPage,
      "isLoading": _vm.isLoading,
      "withAction": false,
      "withScrollX": true,
      "className": "w-full"
    },
    scopedSlots: _vm._u([{
      key: "content_title",
      fn: function (_ref) {
        var value = _ref.value;
        return [_c('span', {
          attrs: {
            "title": value || '-'
          }
        }, [_vm._v(_vm._s(value || '-'))])];
      }
    }, {
      key: "author",
      fn: function (_ref2) {
        var value = _ref2.value;
        return [_c('span', {
          attrs: {
            "title": value || '-'
          }
        }, [_vm._v(_vm._s(value || '-'))])];
      }
    }, {
      key: "empty",
      fn: function () {
        return [_c('InsightEmptyState', {
          attrs: {
            "variant": _vm.appliedSearchQuery ? 'search' : 'empty'
          }
        })];
      },
      proxy: true
    }])
  }), _vm.totalRows ? _c('div', {
    staticClass: "flex justify-between pt-4 pl-3 pr-3 mt-1 bg-white border-t border-gray-100"
  }, [_c('div', {
    staticClass: "font-semibold"
  }, [_c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("Showing ")]), _vm._v(" " + _vm._s(_vm.firstRowNumber) + "-" + _vm._s(_vm.lastRowNumber) + " "), _c('span', {
    staticClass: "font-normal text-gray-500"
  }, [_vm._v("of")]), _vm._v(" " + _vm._s(_vm.totalRows) + " ")]), _c('div', {
    staticClass: "mb-2"
  }, [_c('t-pagination', {
    attrs: {
      "disabled": _vm.isLoading,
      "total-items": _vm.totalRows,
      "per-page": _vm.perPage
    },
    on: {
      "change": _vm.onChangePage
    },
    model: {
      value: _vm.currentPage,
      callback: function ($$v) {
        _vm.currentPage = $$v;
      },
      expression: "currentPage"
    }
  })], 1)]) : _vm._e()], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }